module.exports = __webpack_public_path__ + "img/tx_use_miao_wu.913dd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tx_use_miao_wu.png
// module id = GXhN
// module chunks = 1